enum Routes {
  LINEUP = "/lineup/overview",
  ETAMANAGER = "/lineup/etamanager"
}

export default Routes;
